// 定义全局变量【可以配置多个后端】

const rootUrl = "https://artanalysis.cxstar.cn" + "/art_analysis_back"; // 线上

const globalUrl = {
  rootUrl: rootUrl,

  uploadFile: rootUrl + "/file_upload/", // pdf上传接口

  get_importation_function_operation: rootUrl + "/analysis_art/get_importation_function_operation", // 获取文章要点、方法、实现过程
  abstract_translate: rootUrl + "/analysis_art/translate", // 翻译
  introduction_summarize: rootUrl + "/analysis_art/summarize", // 总结

  get_abstract: rootUrl + "/resolve_pdf/get_abstract", // 获取摘要
  get_introduction: rootUrl + "/resolve_pdf/get_introduction", // 获取简介
  get_content_max20000: rootUrl + "/resolve_pdf/get_content_max20000", // 获取全文，最大两万字
};

export { globalUrl };
